/**
 * Customer Panel Form Utilities
 * 
 * Merkezi form utility fonksiyonları - OOP prensiplerine uygun
 * Tekrar eden form handling kodlarını önler
 */

export interface FormState<T> {
  data: T;
  loading: boolean;
  error: string | null;
  success: boolean;
}

/**
 * Form state initializer
 */
export function createFormState<T>(initialData: T): FormState<T> {
  return {
    data: initialData,
    loading: false,
    error: null,
    success: false,
  };
}

/**
 * Form submit handler wrapper
 * İç içe try/if yapılarını önler
 */
export async function handleFormSubmit<T>(
  formState: FormState<T>,
  submitFn: (data: T) => Promise<void>,
  onSuccess?: () => void,
  onError?: (error: string) => void,
): Promise<{ success: boolean; error: string | null }> {
  formState.loading = true;
  formState.error = null;
  formState.success = false;

  try {
    await submitFn(formState.data);
    formState.success = true;
    onSuccess?.();
    return { success: true, error: null };
  } catch (error) {
    const errorMessage = error instanceof Error ? error.message : 'An error occurred';
    formState.error = errorMessage;
    onError?.(errorMessage);
    return { success: false, error: errorMessage };
  } finally {
    formState.loading = false;
  }
}

/**
 * Password validation
 */
export interface PasswordValidationResult {
  isValid: boolean;
  errors: string[];
}

export function validatePassword(
  password: string,
  confirmation: string,
  minLength: number = 8,
): PasswordValidationResult {
  const errors: string[] = [];

  if (password.length < minLength) {
    errors.push(`Password must be at least ${minLength} characters`);
  }

  if (password !== confirmation) {
    errors.push('Password confirmation does not match');
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
}

